module.exports = __webpack_public_path__ + "GM.png?5181e385aa15036bc0bbbe3ef2cbf8b7";